import { atom } from 'recoil';
import Site from '../../interfaces/api/Site';

export default atom({
  key: 'sites',
  default: {} as { [key: string]: Site },
});
